export default __webpack_public_path__ + "images/0xaa6e8127831c9de45ae56bb1b0d4d4da6e5665bd.png";